var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPenIconGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 40.2498V48.9998H15.75L41.5567 23.1932L32.8067 14.4432L7 40.2498ZM48.3233 16.4265C48.5396 16.2106 48.7113 15.9542 48.8283 15.672C48.9454 15.3897 49.0057 15.0871 49.0057 14.7815C49.0057 14.4759 48.9454 14.1733 48.8283 13.8911C48.7113 13.6088 48.5396 13.3524 48.3233 13.1365L42.8633 7.67651C42.6475 7.4602 42.3911 7.28859 42.1088 7.1715C41.8265 7.05441 41.5239 6.99414 41.2183 6.99414C40.9127 6.99414 40.6101 7.05441 40.3279 7.1715C40.0456 7.28859 39.7892 7.4602 39.5733 7.67651L35.3033 11.9465L44.0533 20.6965L48.3233 16.4265Z",
    fill: "url(#paint0_linear_237_3963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_237_3963",
    x1: 28.0028,
    y1: 6.99414,
    x2: 28.0028,
    y2: 48.9998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.526042,
    stopColor: "#B7F133"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42E365"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenIconGreen);
export default __webpack_public_path__ + "static/media/pen-icon-green.592d43b04ea7327e14f84c7ad73e3ded.svg";
export { ForwardRef as ReactComponent };